var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCutomized(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9991 1L13.0156 9L16.9991 17L25.4726 14.1598L28.3128 5.68629C25.4173 2.79086 21.4173 1 16.9991 1Z",
    fill: "#FFE278"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9993 1C12.9045 1 8.80971 2.56212 5.68555 5.68629L8.52571 14.1598L16.9993 17V1Z",
    fill: "#B0D16F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.68629 5.68652C2.79086 8.58195 1 12.582 1 17.0002L9 20.9837L17 17.0002L5.68629 5.68652Z",
    fill: "#45C5FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 17C1 21.0948 2.56212 25.1896 5.68629 28.3137L14.1598 25.4736L17 17H1Z",
    fill: "#0CA8ED"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.68555 28.3137C8.58098 31.2091 12.581 33 16.9993 33L20.9827 25L16.9993 17L5.68555 28.3137Z",
    fill: "#1365C2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17 33C21.0948 33 25.1896 31.4379 28.3137 28.3137L25.4736 19.8402L17 17V33Z",
    fill: "#F71E78"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3137 28.3137C31.2091 25.4183 33 21.4183 33 17L25 13.0166L17 17L28.3137 28.3137Z",
    fill: "#FF776B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3137 5.68652L17 17.0002H33C33 12.9055 31.4379 8.81069 28.3137 5.68652Z",
    fill: "#FFB54C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCutomized);
export default __webpack_public_path__ + "static/media/Cutomized.1e6031a9c6475994b9448a4c813d8355.svg";
export { ForwardRef as ReactComponent };